import { useRoutes } from 'react-router-dom';
import {
  Company,
  CSAE,
  DeleteAccount,
  FinancialServicesDisclaimer,
  Landing,
  MarketplaceTerms,
  Privacy,
  RiskDisclosurePolicy,
  TermsAndConditions,
} from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/company', element: <Company /> },
    { path: '/delete-my-account', element: <DeleteAccount/> },
    { path: '/terms', element: <TermsAndConditions /> },
    { path: '/financial-services-disclaimer', element: <FinancialServicesDisclaimer /> },
    { path: '/marketplace-terms', element: <MarketplaceTerms /> },
    { path: '/risk-disclosure', element: <RiskDisclosurePolicy /> },
    { path: '/privacy', element: <Privacy /> },
    { path: '/csae', element: <CSAE /> },
  ];
  const routes = publicRoutes;
  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
